var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "session-wrapper justify-center justify-md-start"
    },
    [
      _c("div", {
        staticClass: "session-left"
      }),
      _c(
        "div",
        {
          staticClass: "session-right text-center"
        },
        [
          _c(
            "div",
            {
              staticClass: "session-content"
            },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "login"
                    }
                  }
                },
                [
                  _c("v-img", {
                    staticClass: "img-responsive mb-3",
                    attrs: {
                      src: _vm.logotype
                    }
                  })
                ],
                1
              ),
              _c(
                "h6",
                {
                  staticClass: "mb-3"
                },
                [_vm._v("Unknown Device Verification")]
              ),
              _c(
                "p",
                {
                  staticClass: "caption"
                },
                [
                  _vm._v(
                    " Please enter your E-mail and Password again to verify this request. "
                  )
                ]
              ),
              _c(
                "v-form",
                {
                  staticClass: "mb-4",
                  on: {
                    submit: function submit($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "pa-0"
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|email",
                                    expression: "'required|email'"
                                  }
                                ],
                                attrs: {
                                  label: "E-mail",
                                  outlined: "",
                                  "data-vv-name": "email",
                                  "data-vv-as": "Email",
                                  "error-messages": _vm.errors.collect("email")
                                },
                                model: {
                                  value: _vm.email,
                                  callback: function callback($$v) {
                                    _vm.email =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "email"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Password",
                                  outlined: "",
                                  type: "password",
                                  "data-vv-name": "password",
                                  "data-vv-as": "Password",
                                  "error-messages": _vm.errors.collect(
                                    "password"
                                  )
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function callback($$v) {
                                    _vm.password =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "password"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    type: "submit",
                                    block: "",
                                    tile: "",
                                    dark: "",
                                    large: "",
                                    color: "green",
                                    loading: _vm.loading
                                  },
                                  on: {
                                    click: _vm.login
                                  }
                                },
                                [_vm._v(" Verify Device ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("cookie-law", {
        attrs: {
          theme: "dark-lime"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function fn(props) {
              return [
                _c("p", [
                  _vm._v(
                    " This website uses cookies to ensure you get the best experience on our services. "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.greengeeks.com/legal/privacy",
                        target: "_blank"
                      }
                    },
                    [_vm._v("More details")]
                  )
                ]),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      color: "primary",
                      tile: ""
                    },
                    on: {
                      click: props.accept
                    }
                  },
                  [_vm._v("Got it!")]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }